import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';
import { LinkedService, IModel, Metamodel, ReferenceAdapter, convertParametersToModel } from 'shell-models-lib';
import { ValueAdapter } from './../value.adapter';
import _ from 'lodash';
import { AzureDataExplorerCommandActivity } from 'app/model/pipeline/azure-data-explorer-command.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataExplorerCommandActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            command: '*',
            commandTimeout: '*'
        }
    }
})
export class AzureDataExplorerCommandActivityAdapter extends ActivityAsyncAdapter<AzureDataExplorerCommandActivity, Model.AzureDataExplorerCommandActivity> {

    public model(): IModel {
        return Metamodel.modelFor(AzureDataExplorerCommandActivity);
    }

    protected async _toResource(activity: AzureDataExplorerCommandActivity): Promise<Model.AzureDataExplorerCommandActivity> {
        const modelAzureDataExplorerCommandActivity: Model.AzureDataExplorerCommandActivity =
            super._getCommonActivityProperties(activity, 'AzureDataExplorerCommand') as Model.AzureDataExplorerCommandActivity;
        const adxCommandActivity: AzureDataExplorerCommandActivity = activity as AzureDataExplorerCommandActivity;

        modelAzureDataExplorerCommandActivity.typeProperties = {
            command: ValueAdapter.toResource(adxCommandActivity, AzureDataExplorerCommandActivity.COMMAND),
            commandTimeout: ValueAdapter.toResource(adxCommandActivity, AzureDataExplorerCommandActivity.COMMAND_TIMEOUT)
        };

        if (adxCommandActivity.linkedService) {
            modelAzureDataExplorerCommandActivity.linkedServiceName = this._toLinkedServiceReferenceModel(adxCommandActivity.linkedService, adxCommandActivity.linkedServiceParameters);
        }

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(modelAzureDataExplorerCommandActivity, parsed);
        }

        return modelAzureDataExplorerCommandActivity;
    }

    protected async _toModel(modelActivity: Model.AzureDataExplorerCommandActivity): Promise<AzureDataExplorerCommandActivity> {
        const activity: AzureDataExplorerCommandActivity = AzureDataExplorerCommandActivity.MODEL.create<AzureDataExplorerCommandActivity>(modelActivity.name);
        const modelAzureDataExplorerCommandActivity = modelActivity as Model.AzureDataExplorerCommandActivity;

        this._updatedCommonProperties(modelActivity, activity);

        if (modelAzureDataExplorerCommandActivity.typeProperties) {
            ValueAdapter.toModel(activity, AzureDataExplorerCommandActivity.COMMAND, modelAzureDataExplorerCommandActivity.typeProperties.command);
            ValueAdapter.toModel(activity, AzureDataExplorerCommandActivity.COMMAND_TIMEOUT, modelAzureDataExplorerCommandActivity.typeProperties.commandTimeout);
        }

        if (modelAzureDataExplorerCommandActivity.linkedServiceName !== undefined) {
            activity.linkedService = ReferenceAdapter.toProxyModel<LinkedService>(Metamodel.modelFor(LinkedService), modelAzureDataExplorerCommandActivity.linkedServiceName, this.context);
            if (modelAzureDataExplorerCommandActivity.linkedServiceName.parameters) {
                convertParametersToModel(activity,
                    !!this.context.adapterConfig.replaceIdentitiesForNonConcepts,
                    activity.linkedService,
                    activity.linkedServiceParameters,
                    modelAzureDataExplorerCommandActivity.linkedServiceName.parameters);
            }
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelAzureDataExplorerCommandActivity, AzureDataExplorerCommandActivity.MODEL));

        return activity;
    }
}
